<template>
    <div class="notifications-pipeline">
        <div class="pipeline-container">
            <command-center-table
                title="Notifications"
                icon="fa-light fa-envelopes"
                :columns="pipelineColumns"
                :data="filteredItems"
                :default-page-size="50"
                :active-sort="sort"
                :filterable="false"
                @row-click="onRowClick"
                @sort="onSortChange"
                @filter-change="onColFilterChange"
            >
                <template #toolbar>
                    <span class="k-textbox k-grid-search k-display-flex">
                        <k-input :style="{ width: '300px' }"
                                placeholder="Search in all columns..."
                                :value="searchWord"
                                :icon-name="'search'"
                                @input="onSearchChange"></k-input>
                    </span>
                </template>
            </command-center-table>
        </div>

        <notification-preview-dialog :show-dialog="showNotificationPreviewDialog"
                                     :notification="selectedNotification"
                                     @notificationadded="onNotificationAdded"
                                     @dialogclosed="toggleNotificationPreviewDialog"></notification-preview-dialog>
    </div>
</template>

<script>
    import { Input } from '@progress/kendo-vue-inputs';

    import { orderBy, filterBy } from '@progress/kendo-data-query';

    import cloneDeep from 'lodash.clonedeep';

    import CommandCenterTable from './commandCenter/CommandCenterTable.vue';
    import notificationPreviewDialog from '../components/notificationPreviewDialog.vue';

    export default {
        name: 'NotificationsPipeline',
        props: ['notifications'],
        emits: ['notificationadded'],
        data() {
            return {
                allNotifications: [],
                filter: null,
                filteredItems: [],
                pipelineColumns: [
                    { field: 'category', title: 'Category', width: '150' },
                    { field: 'title', title: 'Title' },
                    { field: 'subject', title: 'Notification Subject' }
                ],
                searchWord: '',
                selectedId: null,
                selectedNotification: null,
                showNotificationPreviewDialog: false,
                sort: [],
            }
        },
        mounted() {
            this.allNotifications = cloneDeep(this.notifications);
            this.getData();
        },
        methods: {
            getData() {
                this.filteredItems = this.getFilteredItems();
            },
            getFilteredItems() {
                let items;

                if (this.searchWord) {
                    items = this.allNotifications.filter(item => {
                        return Object.values(item).some(val => val && val.toString().toLowerCase().includes(this.searchWord.toLowerCase()));
                    });
                } else {
                    items = cloneDeep(this.allNotifications);
                }

                if (this.sort.length > 0) {
                    items = orderBy(items, this.sort);
                }

                if (this.filter) {
                    items = filterBy(items, this.filter);
                }

                return items;
            },
            onColFilterChange({ filters }) {
                if (!filters || filters.length === 0) {
                    this.filter = null;
                } else {
                    this.filter = {
                        logic: 'and',
                        filters: filters.map(f => ({ field: f.field, operator: f.operator, value: f.value }))
                    };
                }
                this.getData();
            },
            onNotificationAdded() {
                this.$emit('notificationadded', this.selectedNotification);
            },
            onRowClick(row) {
                this.selectedNotification = row;
                this.selectedId = row.id;

                this.allNotifications.forEach(item => {
                    item.selected = item.id === this.selectedId;
                });

                this.getData();
                this.toggleNotificationPreviewDialog();
            },
            onSearchChange(evt) {
                this.searchWord = evt.value;
                this.getData();
            },
            onSortChange({ field, dir }) {
                this.sort = [{ field, dir }];
                this.getData();
            },
            toggleNotificationPreviewDialog() {
                this.showNotificationPreviewDialog = !this.showNotificationPreviewDialog;
            }
        },
        components: {
            'k-input': Input,
            'command-center-table': CommandCenterTable,
            'notification-preview-dialog': notificationPreviewDialog
        }
    }
</script>

<style>
    @import '/src/assets/css/notificationsPipeline.css';
</style>